export default "__VITE_ASSET__B21Uwigd__"